import { connect } from 'react-redux';

import {
  getKnmData,
  getKnmIsErknmStatusFillInProcess,
  getKnmTypeFormValue,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { IKnmTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { KnmTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ErknmFillInProcessMessage.module.scss';
import { getKnmErknmFieldsForApproving } from '../selectors/knmErknmSelectors';
import { FieldsForApproving } from '../types/FieldsForApproving';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from '../../../PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IKnm } from '../../../APIPackage/KnmModule/interfaces/IKnm';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';

interface IErknmFillInProcessMessageProps {
  name?: string;
}

interface IErknmFillInProcessMessageStoreProps {
  knmType: IKnmTypeSelectOption | undefined;
  isKnmStatusFillInProcess: boolean;
  fieldsForApproving?: FieldsForApproving;
  settings?: IAdminSetting[];
  knmData?: IKnm;
}

const ErknmFillInProcessMessageWithoutStore = ({
  isKnmStatusFillInProcess,
  knmType,
  name,
  fieldsForApproving,
  settings,
  knmData,
}: IErknmFillInProcessMessageProps & IErknmFillInProcessMessageStoreProps) => {
  const created = knmData?.created || undefined;
  const isLaterThanSetting = isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.FIELDS_MARKS_481_4_1_14);

  if (!isKnmStatusFillInProcess || knmType?.value === KnmTypeCodesEnum.PP248P294 || isLaterThanSetting) {
    return null;
  }

  const isActiveNew = fieldsForApproving && name && fieldsForApproving[name];

  return isActiveNew ? (
    <div className={styles.FillInProcessMessage}>
      <Hint text="Необходимо для согласования" />
    </div>
  ) : null;
};

const mapStateToProps = (state: IRootState): IErknmFillInProcessMessageStoreProps => ({
  knmType: getKnmTypeFormValue(state),
  isKnmStatusFillInProcess: getKnmIsErknmStatusFillInProcess(state),
  fieldsForApproving: getKnmErknmFieldsForApproving(state),
  settings: getAdminFetchSettings(state),
  knmData: getKnmData(state),
});

export const ErknmFillInProcessMessage = connect(mapStateToProps)(ErknmFillInProcessMessageWithoutStore);
